import { useState } from 'react';
import { cariDB } from '../../../lib/cariDB';

type Props = {
  onSaved: () => void;
  onClose: () => void;
};

export default function CariClinicModal({ onSaved, onClose }: Props) {
  const [form, setForm] = useState({ clinic_name: '', contact_name: '', phone: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const isValid = form.clinic_name.trim().length > 0;

  const handleSave = async () => {
    if (!isValid) return;
    setSaving(true);
    setError('');
    try {
      const existing = await cariDB.getClinicByName(form.clinic_name.trim());
      if (existing) {
        setError('Bu klinik adı zaten kayıtlı.');
        setSaving(false);
        return;
      }
      await cariDB.insertClinic({
        clinic_name: form.clinic_name.trim(),
        contact_name: form.contact_name.trim(),
        phone: form.phone.trim(),
      });
      onSaved();
    } catch (e) {
      setError('Kaydedilemedi. Tekrar deneyin.');
      console.error(e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-sm w-full">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-teal-100 rounded-xl flex items-center justify-center">
              <i className="ri-bank-line text-teal-600 text-lg"></i>
            </div>
            <div>
              <h3 className="text-base font-bold text-gray-900">Cari Hesap Ekle</h3>
              <p className="text-xs text-gray-500">Yeni klinik kaydı oluştur</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
              <i className="ri-error-warning-line mr-1.5"></i>{error}
            </div>
          )}

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
              Klinik Adı <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={form.clinic_name}
              onChange={(e) => setForm({ ...form, clinic_name: e.target.value })}
              placeholder="Klinik adı..."
              className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-400 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
              İlgili Kişi
            </label>
            <input
              type="text"
              value={form.contact_name}
              onChange={(e) => setForm({ ...form, contact_name: e.target.value })}
              placeholder="Ad Soyad..."
              className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-400 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
              Telefon
            </label>
            <input
              type="tel"
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
              placeholder="0555 000 00 00"
              className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-400 focus:border-transparent"
            />
          </div>

          <div className="flex gap-3 pt-2">
            <button
              onClick={onClose}
              className="flex-1 py-2.5 border border-gray-200 text-gray-700 rounded-xl font-medium hover:bg-gray-50 whitespace-nowrap cursor-pointer text-sm"
            >
              İptal
            </button>
            <button
              onClick={handleSave}
              disabled={!isValid || saving}
              className={`flex-1 py-2.5 rounded-xl font-semibold text-sm whitespace-nowrap transition-all ${
                isValid && !saving
                  ? 'bg-gradient-to-r from-teal-500 to-cyan-600 text-white hover:from-teal-600 hover:to-cyan-700 cursor-pointer'
                  : 'bg-gray-100 text-gray-400 cursor-not-allowed'
              }`}
            >
              {saving ? (
                <span className="flex items-center justify-center gap-2">
                  <span className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  Kaydediliyor...
                </span>
              ) : 'Kaydet'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
